import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from 'shared/ui';
import { accountTreeModel } from '../../model';
import cls from './account-tree-search.module.scss';

export const AccountTreeSearch = () => {
	const { t } = useTranslation();

	const [value, change] = useUnit([
		accountTreeModel.nameField.$value,
		accountTreeModel.nameField.change,
	]);

	return (
		<SearchInput
			id='account-tree-search-input'
			className={cls.accountTreeSearch}
			value={value}
			label={t('account-tree.name')}
			placeholder={t('account-tree.search')}
			onChange={(e) => change(e.target.value)}
		/>
	);
};
